import {Service} from '../../service';

export class ReportService extends Service {

  static entity = 'app';

  static getSummaryReport(): Promise<any> {
    return this.axios.get(`${this.entity}/summary-report/report-for-vendor`).then(res => res.data);
  }

  static getCounterInvoice(): Promise<any> {
    return this.axios.get(`${this.entity}/summary-report/counter-status-invoice`).then(res => res.data);
  }

  static reloadCounterInvoice(): Promise<any> {
    return this.axios.get(`${this.entity}/summary-report/reload-counter-status-invoice`).then(res => res.data);
  }

}
